export default "https://cdn-static.gokick.com/assets/46c46890c219de5164704b27b734f3ae915944d1/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";